// extracted by css-extract-rspack-plugin
export default {"tabManager":"tabManager-lRAcAC","container":"container-WltuKq","slider":"slider-JDRRRM","tab":"tab-rdLReD","tabActive":"tabActive-dP83BD"};